module.exports = __webpack_public_path__ + "img/3.ff425220.gif";